import { Module } from "vuex";
import { RootState } from "../types";
import { ScheduleMeeting } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  isModalOpened: false,
};

export const scheduleMeeting: Module<ScheduleMeeting, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
